"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makePublicConfig = exports.setPublicConfig = exports.publicConfig = void 0;
const Language_1 = require("../i18n/Language");
const JobRendererVersion_1 = require("../Types/BaseTypes/JobRendererVersion");
const Utils_1 = require("../Utils/Utils");
const Stage_1 = require("./Stage");
let configInstance;
function publicConfig() {
    if (!configInstance) {
        console.warn("Used vp-common-public config before initialization by app package! Initializing with defaults for now.");
        setPublicConfig(makePublicConfig({
            appName: "vp-common-public",
        }));
        (0, Utils_1.assertDefined)(configInstance);
    }
    return configInstance;
}
exports.publicConfig = publicConfig;
function setPublicConfig(cfg) {
    if ((0, Utils_1.isRunningInNode)() || !cfg.stage.isProd) {
        console.log(`${configInstance ? "Overwriting" : "Installing"} public config, appName=${cfg.appName}, stage=${cfg.stage.toString()}`);
    }
    configInstance = cfg;
}
exports.setPublicConfig = setPublicConfig;
function makePublicConfig(overrides) {
    var _a, _b;
    const stage = (_a = overrides.stage) !== null && _a !== void 0 ? _a : Stage_1.Stage.fromEnvironment();
    const stageConfig = makePublicStageConfig(stage);
    return Object.assign(Object.assign({ stage, cognitoUrl: (_b = process.env["VP_COGNITO_URL"]) !== null && _b !== void 0 ? _b : "https://cognito-idp.us-west-2.amazonaws.com", s3RootURL: `https://s3.${stageConfig.s3Bucket.region}.amazonaws.com/${stageConfig.s3Bucket.name}`, urlShortenerEndpointURL: "https://vpng.io", 
        // See https://countrycode.org
        allowedPhoneNumberRegionCodes: "IN,AU,CA,CN,FR,DE,IT,JP,MX,KR,ES,GB,US,QA,MC,LI,LU,MO,NO,CH,AE,SM,DK,SE,AD,AT,FI,BE,IE,IS,NL,NC,NZ,BN,GI,HK,BH,IL,SA,OM,MT,GR,TW,PT,CY,CZ,PL,HR,HU,AR".split(","), textJobKeywords: {
            maxKeywords: 200,
            maxTotalCharLength: 20000,
        } }, stageConfig), overrides);
}
exports.makePublicConfig = makePublicConfig;
function getRenderers() {
    return {
        canariesRendererVersion: JobRendererVersion_1.RendererVersion.v6_1_0,
        jobCreationRendererVersion: JobRendererVersion_1.RendererVersion.v6_1_0,
        autoUpgradeRendererVersion: JobRendererVersion_1.RendererVersion.v6_1_0,
        majorVersionMapping: {
            7: "reg",
            6: "alt",
        },
    };
}
function makePublicStageConfig(stage) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5;
    switch (stage.type) {
        case Stage_1.StageType.Local: {
            const devPrefix = (_a = stage.devPrefix) !== null && _a !== void 0 ? _a : "";
            const developCfg = makePublicStageConfig(Stage_1.Stage.fromParts(Stage_1.StageType.Develop));
            const fallbackDevelopCfg = devPrefix ? undefined : developCfg;
            const rendererAltMappingOverride = (_b = process.env["VP_RENDERER_ALT_MAPPING"]) === null || _b === void 0 ? void 0 : _b.split(",");
            return {
                jobServiceEndpointV2URL: (_d = (_c = process.env["VP_JOB_SERVICE_URL"]) !== null && _c !== void 0 ? _c : fallbackDevelopCfg === null || fallbackDevelopCfg === void 0 ? void 0 : fallbackDevelopCfg.jobServiceEndpointV2URL) !== null && _d !== void 0 ? _d : "http://127.0.0.1:8082/v2/jobs",
                screenshotWorkerEndpointURL: (_f = (_e = process.env["VP_SCREENSHOT_WORKER_URL"]) !== null && _e !== void 0 ? _e : fallbackDevelopCfg === null || fallbackDevelopCfg === void 0 ? void 0 : fallbackDevelopCfg.screenshotWorkerEndpointURL) !== null && _f !== void 0 ? _f : "http://127.0.0.1:8080",
                notificationServiceEndpointURL: (_h = (_g = process.env["VP_NOTIFICATION_SERVICE_URL"]) !== null && _g !== void 0 ? _g : fallbackDevelopCfg === null || fallbackDevelopCfg === void 0 ? void 0 : fallbackDevelopCfg.notificationServiceEndpointURL) !== null && _h !== void 0 ? _h : "http://127.0.0.1:8083",
                subscriptionServiceEndpointURL: (_k = (_j = process.env["VP_SUBSCRIPTION_SERVICE_URL"]) !== null && _j !== void 0 ? _j : fallbackDevelopCfg === null || fallbackDevelopCfg === void 0 ? void 0 : fallbackDevelopCfg.subscriptionServiceEndpointURL) !== null && _k !== void 0 ? _k : "http://127.0.0.1:8084",
                accountServiceEndpointURL: (_m = (_l = process.env["VP_ACCOUNT_SERVICE_URL"]) !== null && _l !== void 0 ? _l : fallbackDevelopCfg === null || fallbackDevelopCfg === void 0 ? void 0 : fallbackDevelopCfg.accountServiceEndpointURL) !== null && _m !== void 0 ? _m : "http://127.0.0.1:8085",
                cmsServiceEndpointURL: (_p = (_o = process.env["CMS_SERVICE_URL"]) !== null && _o !== void 0 ? _o : fallbackDevelopCfg === null || fallbackDevelopCfg === void 0 ? void 0 : fallbackDevelopCfg.cmsServiceEndpointURL) !== null && _p !== void 0 ? _p : "http://127.0.0.1:1337",
                fastshotEndpointURL: (_r = (_q = process.env["VP_FASTSHOT_URL"]) !== null && _q !== void 0 ? _q : fallbackDevelopCfg === null || fallbackDevelopCfg === void 0 ? void 0 : fallbackDevelopCfg.fastshotEndpointURL) !== null && _r !== void 0 ? _r : "http://127.0.0.1:8080/fastshot",
                visualpingWebURL: process.env["VP_WWW_URL"] || "http://localhost:3000",
                hubSpotUrl: "https://api.hsforms.com/submissions/v3/integration/submit",
                cognitoWebClientId: (_t = (_s = process.env["VP_APP_CLIENT_ID_WEB"]) !== null && _s !== void 0 ? _s : process.env["VP_COGNITO_WEB_CLIENT_ID"]) !== null && _t !== void 0 ? _t : "3vmlkrslumnftfa1usib71igf8",
                s3Bucket: {
                    name: (_w = (_v = (_u = process.env["VP_S3BUCKET"]) !== null && _u !== void 0 ? _u : process.env["VP_S3_BUCKET"]) !== null && _v !== void 0 ? _v : fallbackDevelopCfg === null || fallbackDevelopCfg === void 0 ? void 0 : fallbackDevelopCfg.s3Bucket.name) !== null && _w !== void 0 ? _w : `vp-files-ore-${devPrefix.toLowerCase()}`,
                    region: "us-west-2",
                },
                s3FeedbackBucket: {
                    name: (_x = process.env["VP_S3_BUCKET_FEEDBACKS"]) !== null && _x !== void 0 ? _x : "vp-files-feedback-develop",
                    region: "us-west-2",
                },
                i18n: {
                    fallbackLng: Language_1.SupportedLanguage.EN,
                    supportedLngs: Object.values(Language_1.SupportedLanguage),
                },
                intercomAppId: "kfesmi3r",
                renderers: Object.assign(Object.assign({}, getRenderers()), { majorVersionMapping: {
                        7: (rendererAltMappingOverride === null || rendererAltMappingOverride === void 0 ? void 0 : rendererAltMappingOverride.includes("7")) ? "alt" : "reg",
                        6: (rendererAltMappingOverride === null || rendererAltMappingOverride === void 0 ? void 0 : rendererAltMappingOverride.includes("6")) ? "alt" : "reg",
                    } }),
                rudderStack: {
                    token: "21LYOke0ENlTWvTQoXqNJ1hs364",
                    dataPlaneUrl: "https://visualpingjzt.dataplane.rudderstack.com",
                },
                googleAds: {
                    conversionId: "AW-10817036308",
                },
                googleAnalytics: {
                    trackingId: "UA-213399232-1",
                    options: {
                        cookieDomain: "none",
                    },
                },
                honeycomb: {
                    limitedWriteKey: "1URa8NU4xZxe35Z8SGecsI",
                },
                fpTrackingId: "",
                mixPanelToken: "",
                slackAppClientId: "2537973274.5907499425776",
                slackAppAuthRedirectUri: "https://teamsapi.ddnsto.net/slack/auth",
                slackAppEventRequestUrL: "https://teamsapi.ddnsto.net/slack/event",
                googleChatRedirectUrl: "https://1e22-208-87-198-18.ngrok-free.app/googleChat/login/google",
                reCaptchaSiteKeys: {
                    v2: "6LcyM1AjAAAAAJNHgdBpCxL4RDyK2p8xsTrQR-id",
                    v3: "6LeODFAjAAAAAMyPlYB0vextBG4LYP0zF4WMs7-P",
                },
            };
        }
        case Stage_1.StageType.Develop:
            return {
                jobServiceEndpointV2URL: "https://develop.job.api.visualping.io/v2/jobs",
                screenshotWorkerEndpointURL: "https://develop.screenshot.api.visualping.io",
                notificationServiceEndpointURL: "https://develop.notification.api.visualping.io",
                subscriptionServiceEndpointURL: "https://develop.subscription.api.visualping.io",
                accountServiceEndpointURL: "https://develop.account.api.visualping.io",
                cmsServiceEndpointURL: "https://develop.cms.visualping.io/",
                fastshotEndpointURL: "https://develop.screenshot.api.visualping.io/screenshot/fastshot",
                visualpingWebURL: "https://dev.visualping.io",
                hubSpotUrl: "https://api.hsforms.com/submissions/v3/integration/submit",
                cognitoWebClientId: (_z = (_y = process.env["VP_APP_CLIENT_ID_WEB"]) !== null && _y !== void 0 ? _y : process.env["VP_COGNITO_WEB_CLIENT_ID"]) !== null && _z !== void 0 ? _z : "3vmlkrslumnftfa1usib71igf8",
                s3Bucket: { name: "vp-files-ore-develop", region: "us-west-2" },
                s3FeedbackBucket: { name: "vp-files-feedback-develop", region: "us-west-2" },
                i18n: {
                    fallbackLng: Language_1.SupportedLanguage.EN,
                    supportedLngs: Object.values(Language_1.SupportedLanguage),
                },
                intercomAppId: "kfesmi3r",
                renderers: getRenderers(),
                rudderStack: {
                    token: "21LYOke0ENlTWvTQoXqNJ1hs364",
                    dataPlaneUrl: "https://visualpingjzt.dataplane.rudderstack.com",
                },
                honeycomb: {
                    limitedWriteKey: "Hbszezm07vkyf0KH1aYn4M",
                },
                googleAds: {
                    conversionId: "AW-10817036308",
                },
                googleAnalytics: {
                    trackingId: "UA-213399232-1",
                    options: {
                        cookieDomain: "none",
                    },
                },
                fpTrackingId: "",
                mixPanelToken: "",
                slackAppClientId: "2537973274.5884450527987",
                slackAppAuthRedirectUri: "https://develop.notification.api.visualping.io/slack/auth",
                slackAppEventRequestUrL: "https://develop.notification.api.visualping.io/slack/event",
                googleChatRedirectUrl: "https://develop.notification.api.visualping.io/googleChat/login/google",
                reCaptchaSiteKeys: {
                    v2: "6LcyM1AjAAAAAJNHgdBpCxL4RDyK2p8xsTrQR-id",
                    v3: "6LeODFAjAAAAAMyPlYB0vextBG4LYP0zF4WMs7-P",
                },
            };
        case Stage_1.StageType.Beta:
            return {
                jobServiceEndpointV2URL: "https://beta.job.api.visualping.io/v2/jobs",
                screenshotWorkerEndpointURL: "https://beta.screenshot.api.visualping.io",
                notificationServiceEndpointURL: "https://beta.notification.api.visualping.io",
                subscriptionServiceEndpointURL: "https://beta.subscription.api.visualping.io",
                accountServiceEndpointURL: "https://beta.account.api.visualping.io",
                cmsServiceEndpointURL: "",
                fastshotEndpointURL: "https://beta.screenshot.api.visualping.io/screenshot/fastshot",
                visualpingWebURL: "https://beta.visualping.io",
                hubSpotUrl: "https://api.hsforms.com/submissions/v3/integration/submit",
                cognitoWebClientId: (_1 = (_0 = process.env["VP_APP_CLIENT_ID_WEB"]) !== null && _0 !== void 0 ? _0 : process.env["VP_COGNITO_WEB_CLIENT_ID"]) !== null && _1 !== void 0 ? _1 : "19fdnb5j86so7rf116grvn7k3f",
                s3Bucket: { name: "vp-files-ore-beta", region: "us-west-2" },
                s3FeedbackBucket: { name: "vp-files-feedback-beta", region: "us-west-2" },
                i18n: {
                    fallbackLng: Language_1.SupportedLanguage.EN,
                    supportedLngs: Object.values(Language_1.SupportedLanguage),
                },
                intercomAppId: "kfesmi3r",
                renderers: getRenderers(),
                rudderStack: {
                    token: "21LYOke0ENlTWvTQoXqNJ1hs364",
                    dataPlaneUrl: "https://visualpingjzt.dataplane.rudderstack.com",
                },
                googleAds: {
                    conversionId: "AW-10817036308",
                },
                honeycomb: {
                    limitedWriteKey: "uV37vxDvXeQoXaSiGCtqRD",
                },
                googleAnalytics: {
                    trackingId: "UA-213399232-1",
                    options: {
                        cookieDomain: "none",
                    },
                },
                fpTrackingId: "",
                mixPanelToken: "",
                slackAppClientId: "2537973274.5870039928439",
                slackAppAuthRedirectUri: "https://beta.notification.api.visualping.io/slack/auth",
                slackAppEventRequestUrL: "https://beta.notification.api.visualping.io/slack/event",
                googleChatRedirectUrl: "https://beta.notification.api.visualping.io/googleChat/login/google",
                reCaptchaSiteKeys: {
                    v2: "6LcyM1AjAAAAAJNHgdBpCxL4RDyK2p8xsTrQR-id",
                    v3: "6LeODFAjAAAAAMyPlYB0vextBG4LYP0zF4WMs7-P",
                },
            };
        case Stage_1.StageType.Preview:
            return {
                jobServiceEndpointV2URL: "https://preview.job.api.visualping.io/v2/jobs",
                screenshotWorkerEndpointURL: "https://preview.screenshot.api.visualping.io",
                notificationServiceEndpointURL: "https://preview.notification.api.visualping.io",
                subscriptionServiceEndpointURL: "https://preview.subscription.api.visualping.io",
                accountServiceEndpointURL: "https://preview.account.api.visualping.io",
                cmsServiceEndpointURL: "",
                fastshotEndpointURL: "https://preview.screenshot.api.visualping.io/screenshot/fastshot",
                visualpingWebURL: "https://preview.visualping.io",
                hubSpotUrl: "https://api.hsforms.com/submissions/v3/integration/submit",
                cognitoWebClientId: (_3 = (_2 = process.env["VP_APP_CLIENT_ID_WEB"]) !== null && _2 !== void 0 ? _2 : process.env["VP_COGNITO_WEB_CLIENT_ID"]) !== null && _3 !== void 0 ? _3 : "7fe0rdfjs2hfp9ecr7gikdmkvo",
                s3Bucket: { name: "vp-files-ore-preview", region: "us-west-2" },
                s3FeedbackBucket: { name: "vp-files-feedback-preview", region: "us-west-2" },
                i18n: {
                    fallbackLng: Language_1.SupportedLanguage.EN,
                    supportedLngs: Object.values(Language_1.SupportedLanguage),
                },
                intercomAppId: "kfesmi3r",
                renderers: getRenderers(),
                rudderStack: {
                    token: "21LYOke0ENlTWvTQoXqNJ1hs364",
                    dataPlaneUrl: "https://visualpingjzt.dataplane.rudderstack.com",
                },
                googleAds: {
                    conversionId: "AW-10817036308",
                },
                honeycomb: {
                    limitedWriteKey: "gjsXkdLRNzaqPLFEUlD7ZC",
                },
                googleAnalytics: {
                    trackingId: "UA-213399232-1",
                    options: {
                        cookieDomain: "none",
                    },
                },
                fpTrackingId: "",
                mixPanelToken: "",
                slackAppClientId: "2537973274.5907562184656",
                slackAppAuthRedirectUri: "https://preview.notification.api.visualping.io/slack/auth",
                slackAppEventRequestUrL: "https://preview.notification.api.visualping.io/slack/event",
                googleChatRedirectUrl: "https://preview.notification.api.visualping.io/googleChat/login/google",
                reCaptchaSiteKeys: {
                    v2: "6LcyM1AjAAAAAJNHgdBpCxL4RDyK2p8xsTrQR-id",
                    v3: "6LeODFAjAAAAAMyPlYB0vextBG4LYP0zF4WMs7-P",
                },
            };
        case Stage_1.StageType.Prod:
            return {
                jobServiceEndpointV2URL: "https://job.api.visualping.io/v2/jobs",
                screenshotWorkerEndpointURL: "https://screenshot.api.visualping.io",
                notificationServiceEndpointURL: "https://notification.api.visualping.io",
                subscriptionServiceEndpointURL: "https://subscription.api.visualping.io",
                accountServiceEndpointURL: "https://account.api.visualping.io",
                cmsServiceEndpointURL: "https://cms.visualping.io/",
                fastshotEndpointURL: "https://screenshot.api.visualping.io/screenshot/fastshot",
                fastshotAltEndpointURL: "https://prod-alt.screenshot.api.visualping.io/screenshot/fastshot",
                visualpingWebURL: "https://visualping.io",
                hubSpotUrl: "https://api.hsforms.com/submissions/v3/integration/submit",
                cognitoWebClientId: (_5 = (_4 = process.env["VP_APP_CLIENT_ID_WEB"]) !== null && _4 !== void 0 ? _4 : process.env["VP_COGNITO_WEB_CLIENT_ID"]) !== null && _5 !== void 0 ? _5 : "7cnu4rrshp5onnh7gtpfhvg9dl",
                s3Bucket: { name: "vp-files-ore", region: "us-west-2" },
                s3FeedbackBucket: { name: "vp-files-feedback", region: "us-west-2" },
                i18n: {
                    fallbackLng: Language_1.SupportedLanguage.EN,
                    supportedLngs: Object.values(Language_1.SupportedLanguage),
                },
                intercomAppId: "kfesmi3r",
                renderers: getRenderers(),
                rudderStack: {
                    token: "211nTKp5iC53LNxpuaDYK3zjsGQ",
                    dataPlaneUrl: "https://visualpingjzt.dataplane.rudderstack.com",
                },
                googleAds: {
                    conversionId: "AW-10817036308",
                },
                honeycomb: {
                    limitedWriteKey: "Sc5AuBCO6amRjMJtcOS4hD",
                },
                googleAnalytics: {
                    trackingId: "UA-39621438-2",
                    options: {
                        cookieDomain: "none",
                    },
                },
                fpTrackingId: "273597324217988",
                mixPanelToken: "",
                slackAppClientId: "2537973274.1335230692950",
                slackAppAuthRedirectUri: "https://notification.api.visualping.io/slack/auth",
                slackAppEventRequestUrL: "https://notification.api.visualping.io/slack/event",
                googleChatRedirectUrl: "https://notification.api.visualping.io/googleChat/login/google",
                reCaptchaSiteKeys: {
                    v2: "6Ld42QAmAAAAAG_yPTacOhp2bq9L4kSm7kl8PjyC",
                    v3: "6LcEKNclAAAAAI4-5VH4zOYlWzqYZmoCKCGUfSRx",
                },
            };
        case Stage_1.StageType.ProdAlt:
            return makePublicStageConfig(Stage_1.Stage.fromParts(Stage_1.StageType.Prod));
    }
}
//# sourceMappingURL=PublicConfig.js.map